import {userListSuccess, userListError } from "./reducer";
import {getUserList as getUserListApi} from "../../../helpers/user_helper";

export const getUserList = () => async (dispatch) => {
  try {
    let response;
    response = getUserListApi();

    const data = await response;
    if (data) {
      dispatch(userListSuccess(data));
    }
  } catch (error) {
    dispatch(userListError(error));
  }
};
